const api = "https://b684c9a8e00a795d.mokky.dev/";
export const itemsApi = api + 'items'
export const ordersApi = api + 'orders'
export const reviewsApi = api + 'reviews'
export const categoriesApi = api + 'categories'
export const adminApi = api + 'admin'
export const servicesApi = api + 'services'